import i18n from '@/i18n';

/** IPE 用户密码：至少 8 位，须含大写、小写、数字，可含常见符号 */
export const IPE_PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\x20-\x7E]{8,128}$/;

export const IPE_PASSWORD_REQUIREMENT_TEXT =
  '密码至少 8 位，须包含大写字母、小写字母和数字，可包含符号（如 @、#、-）';

function passwordText(key, fallback) {
  if (!i18n.isInitialized) return fallback;
  return i18n.t(key, { ns: 'login', defaultValue: fallback });
}

export function validateIpePassword(password) {
  const value = String(password ?? '');
  if (!value) return passwordText('auth.passwordRequired', '请输入密码');
  if (!IPE_PASSWORD_PATTERN.test(value)) {
    return passwordText('auth.passwordRule', IPE_PASSWORD_REQUIREMENT_TEXT);
  }
  return null;
}
